// const location = process.env.REACT_APP_BASE_URL

const location = "https://www.g2g-api.com";
const LOCAL_DOMAINS = ["localhost", "127.0.0.1"];

const urlConditional = () => {
  if (LOCAL_DOMAINS.includes(window.location.hostname)) {
    return "http://localhost:8000";
  } else {
    return location;
  }
};

export default urlConditional;
